import {
	createElement,
	getCheckboxFieldTemplate,
	getRadioFieldTemplate,
	securityGate
} from "../../../../../../lib";
import ProgressBar from "./progress-bar";
import DOMHelper from "../../../../../../lib/dom-helper";
import Api from "../../../../../../lib/api";

export default class QuestionPage {
	constructor($root, mainController) {
		/* HTML elements */
		this.$root = $root;

		this.$questionSection = this.$root.querySelector('.quiz-question');
		this.$answersSection = this.$root.querySelector('.quiz-options');

		this.$questionNumber = this.$questionSection.querySelector('.quiz-question_number');
		this.$questionText = this.$questionSection.querySelector('.quiz-question_text');
		this.$questionTip = this.$questionSection.querySelector('.quiz-question_description');
		this.$codeBlock = this.$questionSection.querySelector('.quiz-question_code');

		/* Components */
		this.mainController = mainController;
		this.progressBar = new ProgressBar(this.$root);

		this.currentQuestion = null;
	}

	init() {
		this.currentQuestion = this.mainController.getCurrentQuestion();
		this.progressBar.init(this.mainController.getTotalQuestions(), this.currentQuestion.index);
		this.render();
	}

	switchQuestionPage(dir) {
		const isNext = dir === 'next';
		this.mainController.updateState(isNext);
		this.currentQuestion = this.mainController.getCurrentQuestion();
		this.progressBar.next(this.mainController.getCurrentIndex());
		this.render();
	}

	saveUserAnswer() {
		let userAnswers = {};
		const $answerBlocksList = this.$answersSection.querySelectorAll('label');
		$answerBlocksList.forEach(($item) => {
			const $option = $item.closest('.quiz-options_item')
			const isChecked = !!$option.querySelectorAll('.checked').length;
			const id = $option.dataset.id;
			userAnswers[id] = isChecked ? '1' : '';
		});
		this.mainController.saveAnswer(userAnswers);
	}

	render() {
		this.setQuestionSection();
		this.setAnswerSection();
	}

	setQuestionSection() {
		this.$questionNumber.textContent = this.currentQuestion.index + 1;
		this.$questionText.textContent = this.currentQuestion.question;
		if (this.currentQuestion.description) {
			this.$questionTip.textContent = this.currentQuestion.description;
			DOMHelper.show(this.$questionTip);
		} else {
			DOMHelper.hide(this.$questionTip);
		}
		if (this.currentQuestion.code) {
			this.$codeBlock.textContent = this.currentQuestion.code;
			DOMHelper.show(this.$codeBlock);
		} else {
			DOMHelper.hide(this.$codeBlock);
		}
	}

	setAnswerSection() {
		this.$answersSection.innerHTML = '';
		this.currentQuestion.answers.forEach((item, i) => {
			this.setAnswer(item, i);
		});
	}

	setAnswer(data, index) {
		const answerText = data.answer;
		const answerField = this.currentQuestion.type === 'radio' ?
			getRadioFieldTemplate(answerText, 'group'):
			getCheckboxFieldTemplate(answerText);

		const answerElem = DOMHelper.createElement('div', {
			attributes: {
				class: 'quiz-options_item',
				'data-id': index
			},
			html: answerField,
			$parent: this.$answersSection
		});

		//if user has already answered this question set appropriate field selected
		if (data.answered === '1') {
			const $input = answerElem.querySelector('input');
			$input.checked = true;
			$input.closest('label').classList.add('checked');

		}
	}

	setFidCid() {
		let cookie = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');
		const value = (cookie) ? decodeURIComponent(cookie[1]) : null;
		if (value) {
			cookie = value.match(/(\d+\.\d+)$/);
		}
		const cid = (cookie) ? cookie[1] : null;
		let fid = costorage.get('fid') || null;

		if (fid == null) {
			fid = 'f' + Math.floor((Math.random() * 1000000000) + 1) + '.' + Math.round(Date.now() / 1000)
			costorage.set('fid', fid, {expires: 30, path: '/', domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' });
		}

		this.cid = cid;
		this.fid = fid;
	}

	sendForm(data = {}) {
		this.setFidCid();
		const resultData = this.mainController.getResult();

		let formData = {
			lang: document.querySelector('html').lang,
			fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
			fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
			cid: this.cid,
			fid: this.fid,
			referrer: location.href,
			city: craft.env.cityId || Api.currentCityId,
			course: craft.page.courseDirectoryId,
			type: 'quiz-consultation',
			ratio: resultData.ratio,
			answers: resultData.questionList,
			passGrade: resultData.quizPassGrade,
			quizId: this.mainController.config.entryId,
			quizTitle: this.mainController.getQuizTitle()
		};

		formData = Api.updateAndReturnDataWithUtmTags(formData);

		if (securityGate(this.mainController.config.extraSlug)) {
			formData["quizExtraSlug"] = this.mainController.config.extraSlug;
		}

		Object.assign(formData, data);
		delete formData['fromStorage'];

		Api.post(this.mainController.postUrl, formData)
			.catch((err) => {
				console.error('Quiz:', err);
			});

		/* FB Analytics data for backend */
		Api.sendFbEvent('AddToCart', {
			entryId: craft.page.coursesStatsConfig.entryId
		});
	}
}